import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { IGeneralProps } from "types";
import { TalentProfile } from "features/settings/types";

export const QUERY_KEY_FOR_JOB_APPLICANTS = "job-applicants";

const getJobApplicants = async (
    props: IGeneralProps
) => {
    const id = props.id;
    const url = `${END_POINT.BASE_URL}/v1/view_applicants/${id}`;
    const config = {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${props.token}`,
        },
    };

    const res = await axios.get(url, config);
    const data = res.data;


    return data;
};

export const useGetJobListingApplicants = ({ id, token }: IGeneralProps) => {
    const queryData = useQuery([QUERY_KEY_FOR_JOB_APPLICANTS, id], () =>
        getJobApplicants({
            id,
            token,
        })
    );

    return queryData;
};
